import Vue from 'vue'
import Router from 'vue-router'


//运输 业务/////////////////
const trans_short = () => import("@/components/ys_dt/trans_short"); //短途运输登记
const trans_m_over = () => import("@/components/ys_dt/trans_m_over"); //短途运输完成
const trans_d_over = () => import("@/components/ys_dt/trans_d_over"); //费用明细流水	

const trans_pay_m = () => import("@/components/ys_dt/trans_pay_m"); //结算 主
const trans_pay_d = () => import("@/components/ys_dt/trans_pay_d"); //结算 明细流水	

const petty_cash_apply = () => import("@/components/ys_dt/petty_cash_apply"); 	//备用金申请
const petty_cash_off = () => import("@/components/ys_dt/petty_cash_off"); 		//备用金销账
const petty_cash_list = () => import("@/components/ys_dt/petty_cash_list"); 	//备用金挂帐
const petty_cash_listD = () => import("@/components/ys_dt/petty_cash_listD"); 	//备用金挂帐

const transother = () => import("@/components/ys_dt/trans_other"); 	//短途运输合计



Vue.use(Router)

//运输业务//////////////////////////
export default [

	{
		name: "trans_short",
		path: "/trans_short",
		component: trans_short,
		meta: {
			requiresAuth: false,
			keepAlive: false, // 不需要被缓存
			title: "短途运输登记"
		}
	},
	{
		name: "petty_cash_apply",
		path: "/petty_cash_apply",
		component: petty_cash_apply,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "备用金申请"
		}
	},
	{
		name: "petty_cash_off",
		path: "/petty_cash_off",
		component: petty_cash_off,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "备用金销账"
		}
	},
	{
		name: "petty_cash_list",
		path: "/petty_cash_list",
		component: petty_cash_list,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "备用金账单"
		}
	},
	{
		name: "petty_cash_listD",
		path: "/petty_cash_listD",
		component: petty_cash_listD,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "备用金账单明细"
		}
	},
	{
		name: "trans_m_over",
		path: "/trans_m_over",
		component: trans_m_over,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "短途运输完成"
		}
	},
	{
		name: "trans_d_over",
		path: "/trans_d_over",
		component: trans_d_over,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "费用明细流水"
		}
	},
	{
		name: "trans_pay_m",
		path: "/trans_pay_m",
		component: trans_pay_m,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "费用结算"
		}
	},
	{
		name: "trans_pay_d",
		path: "/trans_pay_d",
		component: trans_pay_d,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "费用结算明细"
		}
	},
	{
		name: "trans_other",
		path: "/trans_other",
		component: transother,
		meta: {
			requiresAuth: true,
			keepAlive: true, // 不需要被缓存
			title: "短途运输杂费合计"
		}
	},
	


]
